import config from 'config';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { routes } from '../../../../constants';
import { selectUser } from '../../../../reducers/user.selectors';
import { useAmplitudeExperiment } from '../../../../utils/ampli';
import type { Alert } from '../../../NotificationAlert/NotificationAlert';
import MuiCardBase, { type MuiCardCommonProps } from '../MuiCardBase/MuiCardBase';

export interface MindItemMuiCardProps extends MuiCardCommonProps {
	numberOfPages: number | undefined;
	product?: {
		name: string;
		id: string;
	};
	isNewAddMenuButtonMenu?: boolean;
	onShowNotification?: (alert: Alert) => void;
}

const MindItemMuiCard: React.FC<MindItemMuiCardProps> = (props) => {
	const { t } = useTranslation();
	const user = useSelector(selectUser);
	const { variant: bestMatchVariant, isReady: isBestMatchReady } = useAmplitudeExperiment(
		user,
		config.amplitudeExperiments.bestMatchDeepLink
	);
	const isBestMatchEnabled = isBestMatchReady && bestMatchVariant === 'on';

	const { isFirstElement = false, numberOfPages, product, mindItemPageNumber, ...restProps } = props;

	return (
		<MuiCardBase
			{...restProps}
			mindItemPageNumber={isBestMatchEnabled ? mindItemPageNumber : undefined}
			isFirstElement={isFirstElement}
			contentType="document"
			chipText={
				numberOfPages ? `${numberOfPages} ${numberOfPages === 1 ? t('Page') : t('Pages')}` : undefined
			}
			link={
				product
					? {
							to: `/${routes.productPage.root}/${product.id}`,
							label: product.name,
							icon: 'book',
							hasTooltip: true,
						}
					: undefined
			}
		/>
	);
};

export default MindItemMuiCard;
